import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Company } from './company.model';

export interface ICompanyService {
  allCompanies$: Observable<Company[]>;
}

@Injectable({
  providedIn: 'root',
})
export class CompanyService implements ICompanyService {
  private http = inject(HttpClient);

  private url = `${inject(RUNTIME_CONFIG).apiUrl}/companies`;
  private _allCompaniesSubject = new BehaviorSubject<Company[]>([]);

  constructor() {
    this.loadAllCompanies();
  }

  get allCompanies$(): Observable<Company[]> {
    return this._allCompaniesSubject.asObservable();
  }

  private loadAllCompanies() {
    this.http.get<Company[]>(this.url).subscribe((companies) => {
      this._allCompaniesSubject.next(companies);
    });
  }

  findById(id: string): Company {
    const companies = this._allCompaniesSubject.getValue();
    const company = companies.find((c) => c.id === id);
    if (!company) {
      throw new Error(`Company with id ${id} not found`);
    }
    return company;
  }

  update(company: Company): Observable<Company> {
    return this.http
      .put<Company>(`${this.url}/${company.id}`, company)
      .pipe(tap(() => this.loadAllCompanies()));
  }
}
